import { FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE } from '../constants'
import { store } from '../state/store'
import { setTaxInformation } from '../state/slices/posState/posStateSlice'
import { getFeatureFromCache } from '../util/feature-cache'
import { getTaxInformation } from './tax-information'

/**
 * Fetch tax information and store it in redux.
 */
export const initTaxInformation = async (): Promise<void> => {
  if (
    !getFeatureFromCache(FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE)
  ) {
    return
  }

  try {
    const taxInformation = await getTaxInformation()
    store.dispatch(setTaxInformation(taxInformation))
  } catch (err) {
    // TODO: add back this error once the tax-information endpoint doesn't error when called by a non-admin user
    // trackError('[initTaxInformation] Failed to fetch tax information', {
    //   data: { err },
    // })
  }
}
